import React, { useEffect, useLayoutEffect, useState } from 'react';
import calculateBoundingBoxes, { ChildKeyToDomRect } from './calculate-bounding-boxes';
import usePrevious from '../../custom-hooks/use-previous/use-previous';

// Mostly taken from
// https://medium.com/ft-product-technology/animating-list-reordering-with-react-hooks-1aa0d78a24dc

const AnimateMovingItems = ({ children }) => {
	const [boundingBox, setBoundingBox] = useState<ChildKeyToDomRect>({});
	const [prevBoundingBox, setPrevBoundingBox] = useState<ChildKeyToDomRect>({});
	const prevChildren = usePrevious(children);

	useLayoutEffect(() => {
		const newBoundingBox = calculateBoundingBoxes(children);
		setBoundingBox(newBoundingBox);
	}, [children]);

	useLayoutEffect(() => {
		const prevBoundingBox = calculateBoundingBoxes(prevChildren);
		setPrevBoundingBox(prevBoundingBox);
	}, [prevChildren]);

	useEffect(() => {
		const hasPrevBoundingBox = Object.keys(prevBoundingBox).length;

		if (!hasPrevBoundingBox) {
			return;
		}

		React.Children.forEach(children, child => {
			if (!child.ref?.current) {
				return;
			}
			const domNode: HTMLElement = child.ref.current;
			const firstBox = prevBoundingBox[child.key];
			const lastBox = boundingBox[child.key];

			if (!firstBox || !lastBox) {
				return;
			}
			const changeInY = firstBox.top - lastBox.top;
			const changeInX = firstBox.left - lastBox.left;

			if (!changeInY && !changeInX) {
				return;
			}

			requestAnimationFrame(() => {
				// Before the DOM paints, invert child to old position
				domNode.style.transform = `translateY(${changeInY}px) translateX(${changeInX}px)`;
				domNode.style.transition = 'transform 0s';

				requestAnimationFrame(() => {
					// After the previous frame, remove
					// the transition to play the animation
					domNode.style.transform = '';
					domNode.style.transition = 'transform 500ms ease-in-out 0ms';
				});
			});
		});
	}, [boundingBox, prevBoundingBox, children]);

	return children;
};

export default AnimateMovingItems;
